import React from "react";
import {
  ComposedChart,
  Line,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

import { getRandomIntInclusive } from "@intelligems/ig-utils/common";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

interface TimeSeriesSkeletonProps {
  useLargeDataset?: boolean;
}

export const TimeSeriesSkeleton = ({
  useLargeDataset,
}: TimeSeriesSkeletonProps) => {
  const theme = useTheme();
  const fakeLineData = [
    "Page A",
    "Page B",
    "Page C",
    "Page D",
    "Page E",
    "Page F",
    "Page G",
  ].map((page) => ({
    name: page,
    ...Object.fromEntries(
      [...Array(useLargeDataset ? 3 : 2).keys()].map((item) => [
        item,
        getRandomIntInclusive(5, 10),
      ])
    ),
  }));
  const grayHexCodes = [
    theme.igPrimitives.gray["A100"],
    theme.igPrimitives.gray[900],
    theme.igPrimitives.gray[800],
    theme.igPrimitives.gray[900],
    theme.igPrimitives.gray[700],
    theme.igPrimitives.gray["A100"],
    theme.igPrimitives.gray[700],
    theme.igPrimitives.gray[900],
  ];
  const lineKeys = Object.keys(fakeLineData[0]).filter((key) => key !== "name");

  return (
    <Grid>
      <ResponsiveContainer width="100%" height={300}>
        <ComposedChart
          width={500}
          height={300}
          data={fakeLineData}
          margin={{
            top: 15,
            bottom: 5,
          }}
        >
          <text
            className="infinite-pulsing"
            x="50%"
            y="80%"
            // dy={+12}
            style={{
              fontSize: "14px",
              fill: theme.palette.text.secondary,
              lineHeight: "20px",
              letterSpacing: ".25px",
            }}
            textAnchor="middle"
          >
            Loading Data
          </text>

          <XAxis
            dataKey={"xAxisKey"}
            tickLine={false}
            tick={false}
            axisLine={{ stroke: theme.igBorders.core.disabled }}
            style={{ fontFamily: theme.typography.fontFamily, fontSize: 10 }}
          />

          <YAxis
            type={"number"}
            axisLine={{ stroke: theme.igBorders.core.disabled }}
            style={{ fontFamily: theme.typography.fontFamily, fontSize: 10 }}
            tickLine={false}
            tick={false}
          />

          {lineKeys.map((key, index) => (
            <Line
              className="pulsing-line"
              key={key}
              type="monotone"
              strokeWidth={1.5}
              dot={false}
              dataKey={key}
              stroke={index > 7 ? "gray" : grayHexCodes[index]}
              fill={index > 7 ? "gray" : grayHexCodes[index]}
            />
          ))}
        </ComposedChart>
      </ResponsiveContainer>
    </Grid>
  );
};
